import { createAction } from 'redux-actions';
import * as labelReviewValidationFormTypes from './labelReviewValidationFormTypes';

export const onSaveButtonClick = createAction(labelReviewValidationFormTypes.SAVE_BUTTON_CLICK);
